var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container video-demo overflow-x-hidden" }, [
    _c("div", { staticClass: "justify-center" }, [
      _c(
        "ul",
        {
          staticClass: "progressbar clearfix flex justify-center relative pb-6"
        },
        [
          _c(
            "li",
            { staticClass: "active hoverable w-1/4 flex justify-center" },
            [
              _c(
                "span",
                {
                  staticClass:
                    "bg-blue-lighter block w-10 h-10 rounded-full flex items-center justify-center"
                },
                [
                  _vm.step <= 1
                    ? _c("img", {
                        staticClass: "mx-auto",
                        attrs: {
                          src: require("../../images/Icon/fingerprint.svg")
                        }
                      })
                    : _c("img", {
                        staticClass: "mx-auto",
                        attrs: {
                          src: require("../../images/Icon/assets-icon-video-white.svg")
                        }
                      })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm.step >= 2
            ? _c(
                "li",
                { staticClass: "active hoverable w-1/4 flex justify-center" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "block w-10 h-10 rounded-full flex items-center justify-center",
                      class: {
                        "bg-grey": _vm.step < 2,
                        "bg-blue-lighter": _vm.step >= 2,
                        current: _vm.step === 2
                      }
                    },
                    [
                      _vm.step <= 1
                        ? _c("img", {
                            staticClass: "mx-auto",
                            attrs: {
                              src: require("../../images/Icon/fingerprint.svg")
                            }
                          })
                        : _c("img", {
                            staticClass: "mx-auto",
                            attrs: {
                              src: require("../../images/Icon/fingerprint-white.svg")
                            }
                          })
                    ]
                  )
                ]
              )
            : _c("li", { staticClass: "w-1/4 flex justify-center" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "block w-10 h-10 rounded-full flex items-center justify-center",
                    class: {
                      "bg-grey": _vm.step < 2,
                      "bg-blue-lighter": _vm.step >= 2,
                      current: _vm.step === 2
                    }
                  },
                  [
                    _vm.step <= 1
                      ? _c("img", {
                          attrs: {
                            src: require("../../images/Icon/fingerprint.svg")
                          }
                        })
                      : _c("img", {
                          staticClass: "mx-auto",
                          attrs: {
                            src: require("../../images/Icon/fingerprint-white.svg")
                          }
                        })
                  ]
                )
              ]),
          _vm._v(" "),
          _vm.step >= 3
            ? _c(
                "li",
                { staticClass: "active hoverable w-1/4 flex justify-center" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "block w-10 h-10 rounded-full flex items-center justify-center",
                      class: {
                        "bg-grey": _vm.step < 3,
                        "bg-blue-lighter": _vm.step >= 3,
                        current: _vm.step === 3
                      }
                    },
                    [
                      _vm.step < 3
                        ? _c("img", {
                            staticClass: "mx-auto",
                            attrs: {
                              src: require("../../images/Icon/cisor.svg")
                            }
                          })
                        : _c("img", {
                            staticClass: "mx-auto",
                            attrs: {
                              src: require("../../images/Icon/cisor-white.svg")
                            }
                          })
                    ]
                  )
                ]
              )
            : _c("li", { staticClass: "w-1/4 flex justify-center" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "bg-grey block w-10 h-10 rounded-full flex items-center justify-center"
                  },
                  [
                    _vm.step < 3
                      ? _c("img", {
                          staticClass: "mx-auto",
                          attrs: { src: require("../../images/Icon/cisor.svg") }
                        })
                      : _c("img", {
                          staticClass: "mx-auto",
                          attrs: {
                            src: require("../../images/Icon/cisor-white.svg")
                          }
                        })
                  ]
                )
              ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "mb-6" }, [_vm._v(_vm._s(_vm.titlePart))]),
    _vm._v(" "),
    _c("div", { staticClass: "flex mt-6 steps" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "pl-6 w-1/2 step relative flex-shrink-0" }, [
        _c("h4", { staticClass: "text-green mb-4" }, [
          _vm._v("Modified copy: certified")
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex items-center justify-center mt-4",
            on: { click: _vm.toggleTooltip }
          },
          [
            _c("h4", { staticClass: "text-green mr-4" }, [
              _vm._v("Video (" + _vm._s(_vm.video) + ")")
            ]),
            _vm._v(" "),
            _c("img", {
              attrs: { src: require("../../images/Icon/arrow-down-green.svg") }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "dropdown-container absolute h-0 overflow-hidden flex justify-center items-center mt-4"
          },
          [
            _c("ul", { staticClass: "dropdown" }, [
              _c(
                "li",
                {
                  staticClass: "py-2",
                  class: {
                    "bg-blue-lighter text-white": _vm.video === "camcord"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeVideo("camcord")
                    }
                  }
                },
                [_vm._v("Camcord\n                    ")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "py-2",
                  class: { "bg-blue-lighter text-white": _vm.video === "crop" },
                  on: {
                    click: function($event) {
                      return _vm.changeVideo("crop")
                    }
                  }
                },
                [_vm._v("Crop\n                    ")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "py-2",
                  class: {
                    "bg-blue-lighter text-white": _vm.video === "compression"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeVideo("compression")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                        Compression\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "py-2",
                  class: {
                    "bg-blue-lighter text-white": _vm.video === "partial"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeVideo("partial")
                    }
                  }
                },
                [_vm._v("Excerpt\n                    ")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "py-2",
                  class: {
                    "bg-blue-lighter text-white": _vm.video === "color"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeVideo("color")
                    }
                  }
                },
                [_vm._v("Colorimetry\n                    ")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "py-2",
                  class: {
                    "bg-blue-lighter text-white": _vm.video === "sound"
                  },
                  on: {
                    click: function($event) {
                      return _vm.changeVideo("sound")
                    }
                  }
                },
                [_vm._v("No sound\n                    ")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "py-2",
                  class: { "bg-blue-lighter text-white": _vm.video === "all" },
                  on: {
                    click: function($event) {
                      return _vm.changeVideo("all")
                    }
                  }
                },
                [
                  _vm._v(
                    "All attacks\n                        combined\n                    "
                  )
                ]
              )
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-center mt-4" }, [
      _c(
        "button",
        {
          staticClass: "btn bg-green text-blue",
          attrs: { id: "playvideos" },
          on: {
            click: function($event) {
              !_vm.playing ? _vm.play() : _vm.stop()
            }
          }
        },
        [
          _c("i", {
            staticClass: "fa",
            class: { "fa-stop": _vm.playing, "fa-play": !_vm.playing }
          }),
          _vm._v(" Compare video\n        ")
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex justify-center" }, [
      _vm.step === 2
        ? _c(
            "div",
            {
              staticClass: "flex justify-center py-8",
              on: { click: _vm.nextStep }
            },
            [
              _c(
                "button",
                { staticClass: "bg-blue-lighter text-white py-2 mx-auto" },
                [_vm._v("Next step ›")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 3 || _vm.step === 4
        ? _c(
            "div",
            {
              staticClass: "flex justify-center py-8",
              on: { click: _vm.previousStep }
            },
            [
              _c(
                "button",
                { staticClass: "bg-blue-lighter text-white py-2 mx-auto" },
                [_vm._v("‹ Previous step")]
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pr-6 w-1/2 step flex-shrink-0" }, [
      _c("div", [
        _c("h4", { staticClass: "text-green mb-4" }, [
          _vm._v("Original video")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "box uploadbox border-2 border-green bg-transparent flex items-center justify-center mx-auto"
          },
          [_c("div", { attrs: { id: "original" } })]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w-1/2 step flex-shrink-0" }, [
      _c("h4", { staticClass: "text-green mb-4" }, [
        _vm._v("Watermarked video")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "box uploadbox border-2 border-green bg-transparent flex items-center justify-center mx-auto"
        },
        [_c("div", { attrs: { id: "watermarked" } })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "box uploadbox border-2 border-green bg-transparent flex items-center justify-center mx-auto"
      },
      [_c("div", { attrs: { id: "modified" } })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/clementinefernandez/Local Sites/imatag/app/public/wp-content/themes/www/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/clementinefernandez/Local Sites/imatag/app/public/wp-content/themes/www/node_modules/vue-loader/lib?{}!./scripts/demo/WatermarkingDemoVideo.vue?vue&type=template&id=68722019&
// module id = 108
// module chunks = 0